"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlMat2Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl float matrix2 uniform.
 */
class GlMat2Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniformMatrix2fv(this.uniformLocation, this.transpose, data);
        this.isDirty = false;
    }
}
exports.GlMat2Uniform = GlMat2Uniform;
//# sourceMappingURL=gl-mat2-uniform.js.map